import Logo from './logo.vue'
export default Logo